import { useTranslation } from 'next-i18next';
import Link from 'next-translate-routes/link';
import type { FC } from 'react';

import { Icon } from '@/components';
import type { IRateInBestRatesProps } from '@/types';
import { cn } from '@/utils';

export const BestRateItem: FC<IRateInBestRatesProps> = ({
  rate,
  term,
  depositTypeKey,
  url,
  currency,
  itemClassName,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'flex w-[204px] shrink-0 flex-col  justify-between rounded-2xl bg-blue-50 px-5 py-4 md:w-full md:shrink md:rounded-none md:p-0',
        itemClassName,
      )}
    >
      <div>
        <p className="lowercase">
          <span className="body2-bold lowercase text-blue-900">
            {`${term} ${t(`deposit_card.months_short`)}`}{' '}
          </span>
          <span className="body2 lowercase text-grey-800">
            {t(depositTypeKey)}
          </span>
        </p>
        <p className="h4 mt-2">{rate}%</p>
        <p className="body3 mt-0.5 text-grey-800">{currency}</p>
      </div>
      <Link href={url} className="mt-5 block">
        <p className="body3 flex items-center gap-[1px] text-blue-500">
          {t('global.show_more')}
          <Icon name="ArrowLight" className="stroke-transparent" />
        </p>
      </Link>
    </div>
  );
};
